import { z } from 'zod';

export const McmValueSchema = z.object({
  visible: z.boolean(),
  trending: z.boolean(),
});

export const McmKeyValPairSchema = z.record(z.string(), McmValueSchema);

export const McmSchema = z.object({
  syncWithTemplate: z.boolean(),
  endpoints: McmKeyValPairSchema,
});
